import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgMicellarWaterGlyph from './svgs/MicellarWaterGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var micellarWaterGlyph = (props => useIcon(SvgMicellarWaterGlyph, SvgMicellarWaterGlyph, props));

export { micellarWaterGlyph as default };
